/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Video_Url_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Video URL" |
*
* @param {Media_Import_Video_Url_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_video_url_placeholder = /** @type {((inputs?: Media_Import_Video_Url_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Video_Url_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL de la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Video-URL")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL del video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL del vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频网址")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオURL")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो यूआरएल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL do vídeo")
	return /** @type {LocalizedString} */ ("Video URL")
});